const serverPath = 'yhshe.top:8080';

export default {
	serverPath
}


// WEBPACK FOOTER //
// ./src/assets/js/serverPath.js